import React from "react";
import useSWR, { mutate } from "swr";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/app/PageHeader";
import { MissionFormDialog } from "@/components/app/MissionFormDialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { missionLabel, MISSION_STATUS } from "@/lib/labels";

const fetcher = (u) => api.get(u).then((r) => r.data);

function MissionsTable({ missions, isLoading, clientMap, clients, onStatusChange }) {
  return (
    <div className="border border-zinc-200 bg-white rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-zinc-50 border-b border-zinc-200">
          <tr className="text-left text-[10px] uppercase tracking-[0.18em] text-zinc-500">
            <th className="px-4 py-3">Intitulé</th>
            <th className="px-4 py-3">Client</th>
            <th className="px-4 py-3">Type</th>
            <th className="px-4 py-3">Période</th>
            <th className="px-4 py-3">Honoraires</th>
            <th className="px-4 py-3">Statut</th>
            <th className="px-4 py-3 text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-zinc-100">
          {isLoading && <tr><td colSpan={7} className="p-6 text-zinc-500">Chargement…</td></tr>}
          {!isLoading && missions.length === 0 && <tr><td colSpan={7} className="p-6 text-zinc-500">Aucune mission.</td></tr>}
          {missions.map((m) => (
            <tr key={m.id} data-testid={`mission-row-${m.id}`}>
              <td className="px-4 py-3 font-medium">{m.title}</td>
              <td className="px-4 py-3">{clientMap[m.client_id]?.name || "—"}</td>
              <td className="px-4 py-3">{missionLabel(m.mission_type)}</td>
              <td className="px-4 py-3 text-zinc-600">{m.start_date || "—"} → {m.end_date || "—"}</td>
              <td className="px-4 py-3">{m.fees_ht ? `${m.fees_ht.toLocaleString("fr-FR")}` : "—"}</td>
              <td className="px-4 py-3">
                <Select value={m.status} onValueChange={(v) => onStatusChange(m.id, v)}>
                  <SelectTrigger className="h-8 w-32"><SelectValue /></SelectTrigger>
                  <SelectContent>{MISSION_STATUS.map((s) => (<SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>))}</SelectContent>
                </Select>
              </td>
              <td className="px-4 py-3 text-right">
                <MissionFormDialog clients={clients} mission={m} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Missions() {
  const { data: missions = [], isLoading } = useSWR("/missions", fetcher);
  const { data: clients = [] } = useSWR("/clients", fetcher);
  const clientMap = Object.fromEntries(clients.map((c) => [c.id, c]));

  const updateStatus = async (id, status) => {
    await api.put(`/missions/${id}`, { status });
    mutate("/missions");
  };

  return (
    <div>
      <PageHeader
        eyebrow="Production"
        title="Missions"
        description="Portefeuille de missions, avancement et affectation."
        actions={<MissionFormDialog clients={clients} />}
      />
      <MissionsTable missions={missions} isLoading={isLoading} clientMap={clientMap} clients={clients} onStatusChange={updateStatus} />
    </div>
  );
}
